import type { BossRevolveSceneContour } from '@puppycad/cad-core';

/**
 * 将未知错误转换为用户可读文本。
 *
 * @param error 未知错误。
 * @returns 错误消息。
 */
export function resolveRevolveErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : '旋转凸台执行失败。';
}

/**
 * 构建轮廓显示标签。
 *
 * @param contour 当前轮廓。
 * @param index 当前序号。
 * @returns 轮廓标签。
 */
export function buildRevolveContourLabel(contour: BossRevolveSceneContour, index: number): string {
  const sketchLabel = contour.sketchId ? `草图${contour.sketchId.slice(-4)}` : '草图';
  return `${sketchLabel}-轮廓${index + 1}`;
}
